export enum CashTypes {
  cashUp = 'cash',
  float = 'float',
  card = 'card',
  safe = 'safe'
}

export enum SafeActions {
  deposit = 'deposit',
  withdraw = 'withdraw',
  withdrawPettyCash = 'withdraw petty cash',
  count = 'count'
}

